<app-sidenav>
  <mat-nav-list>
    @for (category of categoryData; track category) {
      <div class="overline pb-2 pt-4" style="margin-left: 16px; letter-spacing: 0.1px;">
        {{ category.translations[currentLanguage].name }}:
      </div>

      @for(product of category.products; track product){
        <ng-container *ngIf="product.product as p">
          <ng-container *ngIf="['/products', p.translations[currentLanguage].slug] | localize as localizedProductPath">
            <a mat-list-item [routerLink]="localizedProductPath">
              {{ p.translations[currentLanguage]?.title }}
            </a>
          </ng-container>
        </ng-container>
      }
    }
  </mat-nav-list>
</app-sidenav>
